/**
 * mixin 计算通话时长
 */

// import wxHelp from '../common/wxhelp'
import util from '../../common/util'

export default {
  data () {
    return {
      callOptions: {
        request: 0,
        failure: 0,
        success: 0,
        calling: true,
        lastFailure: null,
        finished: false,
        openLog: false,
        interval: 500,
        st: null,
        threshold: 10 * 1000, // 阈值
        lastTime: null, // 最后一次记时
        complete: (startTime, endTime) => {},
        lastSuccess: null
      }
    }
  },
  methods: {
    getRecordAuth () {
      this.$wechat.promise.then(wx => {
        wx.startRecord(() => {
          this.stopRecord()
        })
      }, wx => {
        window.console.log('微信JSSDK校验错误:', JSON.stringify(wx.res))
      })
      // wxHelp.startRecord(() => {
      //   this.stopRecord()
      // })
    },
    initCall (options) {
      // 重置配置
      Object.assign(this.callOptions, {
        request: 0,
        failure: 0,
        success: 0,
        calling: true,
        lastFailure: null,
        finished: false,
        openLog: false,
        interval: 500,
        st: null,
        threshold: 10 * 1000, // 阈值
        lastTime: null, // 最后一次记时
        lastSuccess: null
      }, options)
      // 监听录音正常结束
      this.$wechat.promise.then(wx => {
        wx.onVoiceRecordEnd((res) => {
          this.callOptions.calling = false
        })
      }, wx => {
        window.console.log('微信JSSDK校验错误:', JSON.stringify(wx.res))
      })
      // wxHelp.onVoiceRecordEnd((res) => {
      //   this.callOptions.calling = false
      // })
      this.startCall()
    },
    startCall () {
      if (this.callOptions.finished) {
        // wxHelp.stopRecord()
        return
      }
      this.callOptions.request++
      this.$wechat.promise.then(wx => {
        wx.startRecord((res) => {
          this.callOptions.calling = true // 录音中
          this.callOptions.success++
          this.log('succ')

          let curTime = this.callOptions.lastSuccess = Date.now()

          // 非第一次记时，且间隔大于阈值
          if (this.callOptions.lastTime && curTime - this.callOptions.lastTime >= this.callOptions.threshold) {
            this.log(`elapsed: ${this.callOptions.lastSuccess - this.callOptions.lastTime}`)
            this.callOptions.finished = true
            this.callOptions.complete(this.callOptions.lastTime, this.callOptions.lastSuccess)
            // 停止录音
            this.stopRecord()
            this.callOptions.calling = false
          } else {
            this.callOptions.lastTime = curTime
          }
        }, (res) => {
          this.callOptions.calling = false
          this.callOptions.failure++

          this.log('failure')
          let curTime = this.callOptions.lastFailure = Date.now()

          // 非第一次记时，且间隔大于阈值
          if (this.callOptions.lastTime && curTime - this.callOptions.lastTime >= this.callOptions.threshold) {
            this.log(`elapsed: ${this.callOptions.lastFailure - this.callOptions.lastTime}`)
            this.callOptions.finished = true
            this.callOptions.complete(this.callOptions.lastTime, this.callOptions.lastFailure)
            // 停止录音
            this.stopRecord()
            this.callOptions.calling = false
          } else {
            this.callOptions.lastTime = curTime
          }
        })
      }, wx => {
        console.log('微信JSSDK校验错误:', wx.res)
      })
      setTimeout(() => {
        this.startCall()
      }, this.callOptions.interval)
    },

    log (str) {
      if (this.callOptions.openLog) {
        let pDom = document.createElement('div')
        pDom.style = 'position:absolute;z-index:999999;min-height:300px;'
        document.body.appendChild(pDom)
        let dom = document.createElement('p')
        dom.innerText = util.formatTime(new Date(), 'yyyy-MM-dd hh:mm:ss') + ': ' + str
        pDom.appendChild(dom)
      }
    },
    stopRecord () {
      if (this.callOptions.calling) { // 如果在录音中
        clearTimeout(this.st)
        this.st = setTimeout(res => {
          this.$wechat.promise.then(wx => {
            wx.stopRecord(res => {
              this.log(`stopRecord>>${JSON.stringify(res)}`)
            }, res => {
              this.log(`stopRecord>>${JSON.stringify(res)}`)
            }, res => {
              this.log(`stopRecord>>${JSON.stringify(res)}`)
            })
          }, wx => {
            console.log('微信JSSDK校验错误:', wx.res)
          })
        }, this.callOptions.interval / 2)
      }
    }
  }
}
